/**
 * The app the person has open, sent as `X-Rudi-App` on every request so
 * product health can tell, say, Patients from Lists on the shared Lists
 * routes (ADR 0086). The web sets it from the active tab, Expo from the
 * current screen. A backend that does not read it ignores it.
 */
export const SHOWN_APP_HEADER = 'X-Rudi-App';

let shownApp: string | null = null;

export function setShownApp(app: string | null): void {
  shownApp = app;
}

export function getShownApp(): string | null {
  return shownApp;
}
